import { render, staticRenderFns } from "./EditAgentDialog.vue?vue&type=template&id=1976eadb"
import script from "./EditAgentDialog.vue?vue&type=script&lang=js"
export * from "./EditAgentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports